import Loadable from 'react-loadable';

import LoadingModal from 'modals/LoadingModal';

export const DeleteHeroSearchModalContainerLoadable = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "DeleteHeroSearchModalContainer" */
      './DeleteHeroSearchModalContainer'
    ),
  loading: LoadingModal,
});
